export default {
  applied: "After Registration",
  accept: "Accepted",
  reject: "Rejected"
};
